
/**
 * List form errors for the user to see.
 */
import { defineComponent } from 'vue';

export default defineComponent({
  props: {
    messages: {
      type: Array as unknown as () => {
        message: string, // note messages should be pre-translated
        hint?: string,
      }[],
      required: true,
    },
  },
});
